import {
	faBook,
	faChartBar,
	faCode,
	faProjectDiagram,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, ButtonBase } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import { useLeftPanelMode } from '@/components/LeftPanelMode'
import { IS_PREVIEW_PAGES_ENABLED } from '@/config'
import { ROUTES } from '@/constants'
import { useAppContext } from '@/hooks'

const tabs = [
	{
		to: ROUTES.PROJECT_VIEW,
		labelKey: 'NAVBAR_TAB_DEVELOPER',
		icon: faCode,
	},
	{
		to: ROUTES.DATA_CATALOG,
		labelKey: 'NAVBAR_TAB_DATA_CATALOG',
		icon: faBook,
	},
	{
		to: ROUTES.REPORTS,
		labelKey: 'NAVBAR_TAB_REPORTS',
		icon: faChartBar,
	},
	{
		to: ROUTES.ONTOLOGY,
		labelKey: 'NAVBAR_TAB_ONTOLOGY',
		icon: faProjectDiagram,
	},
] as const

export const NavBarTabs = () => {
	const { t } = useAppContext()
	const location = useLocation()
	const { openExplorer } = useLeftPanelMode()

	/** Without preview pages, Developer would be the only tab — hide the whole strip. */
	if (!IS_PREVIEW_PAGES_ENABLED) {
		return null
	}

	return (
		<Box
			role="menubar"
			data-testid="navbar-tabs"
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 0.5,
				ml: 3,
			}}
		>
			{tabs.map((tab) => {
				const active =
					tab.to === ROUTES.PROJECT_VIEW
						? location.pathname === ROUTES.PROJECT_VIEW
						: location.pathname.startsWith(tab.to)

				return (
					<ButtonBase
						key={tab.to}
						component={RouterLink}
						to={tab.to}
						role="menuitem"
						aria-current={active ? 'page' : undefined}
						data-testid={`navbar-tab-${tab.labelKey}`}
						onClick={() => {
							if (tab.to === ROUTES.PROJECT_VIEW) {
								openExplorer()
							}
						}}
						sx={{
							display: 'inline-flex',
							alignItems: 'center',
							gap: 0.75,
							px: 1.5,
							py: 0.75,
							borderRadius: '6px',
							fontSize: 14,
							textDecoration: 'none',
							fontWeight: active ? 500 : 400,
							bgcolor: active ? '#fff' : 'transparent',
							color: active ? '#1a2e35' : 'rgba(255,255,255,0.55)',
							'&:hover': {
								bgcolor: active ? '#fff' : 'rgba(255,255,255,0.1)',
								color: active ? '#1a2e35' : 'rgba(255,255,255,0.9)',
							},
						}}
					>
						<FontAwesomeIcon icon={tab.icon} fontSize={12} />
						{t(tab.labelKey)}
					</ButtonBase>
				)
			})}
		</Box>
	)
}
